import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { KeyRound, AlertCircle, Check } from "lucide-react";
import { useAdminAuth } from "../../contexts/AdminAuthContext";

export default function AdminChangePasswordPage() {
  const { admin, changePassword } = useAdminAuth();
  const [oldP, setOld] = useState("");
  const [newP, setNew] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (newP.length < 10) return setErr("Yeni şifre en az 10 karakter olmalı.");
    if (newP !== confirm) return setErr("Yeni şifre ve onay eşleşmiyor.");
    setBusy(true);
    try {
      await changePassword(oldP, newP);
      setOk(true);
      setTimeout(() => navigate("/admin/dashboard", { replace: true }), 900);
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-change-password-page" className="max-w-md mx-auto py-10">
      <Helmet><title>Şifre Değiştir · Admin</title></Helmet>
      <span className="text-xs uppercase tracking-[0.2em] text-brand-pink-deep font-bold">Güvenlik</span>
      <h1 className="mt-2 font-display text-h1 font-bold text-ink">Şifreni güncelle</h1>
      {admin?.must_change_password ? (
        <p className="mt-3 text-sm text-ink/65 rounded-xl bg-brand-pink/10 border border-brand-pink/30 px-4 py-3">
          İlk girişin için zorunlu şifre güncellemesi. Devam etmek için yeni bir şifre belirle.
        </p>
      ) : null}

      <form onSubmit={submit} className="mt-8 space-y-4 rounded-2xl bg-white border border-mist p-6 sm:p-7">
        {[
          { label: "Mevcut şifre", val: oldP, set: setOld, testId: "cp-old" },
          { label: "Yeni şifre (min 10 kar.)", val: newP, set: setNew, testId: "cp-new" },
          { label: "Yeni şifre tekrar", val: confirm, set: setConfirm, testId: "cp-confirm" },
        ].map((f) => (
          <div key={f.testId}>
            <label className="text-xs uppercase tracking-[0.18em] text-ink/55 font-bold">{f.label}</label>
            <input
              type="password" required value={f.val} onChange={(e) => f.set(e.target.value)} data-testid={f.testId}
              className="mt-1.5 w-full rounded-xl border-2 border-mist bg-cream/60 px-4 py-3 text-sm focus:border-brand-pink focus:bg-white outline-none transition-colors"
            />
          </div>
        ))}

        {err ? <div data-testid="cp-error" className="flex items-start gap-2 rounded-xl bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700"><AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" />{err}</div> : null}
        {ok ? <div data-testid="cp-success" className="flex items-start gap-2 rounded-xl bg-green-50 border border-green-200 px-4 py-3 text-sm text-green-700"><Check className="h-4 w-4 flex-shrink-0 mt-0.5" />Şifren güncellendi. Yönlendiriliyorsun…</div> : null}

        <button type="submit" disabled={busy} data-testid="cp-submit"
          className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-ink text-cream px-7 py-3.5 text-sm font-semibold hover:bg-brand-pink-deep transition-colors disabled:opacity-60">
          <KeyRound className="h-4 w-4" />
          {busy ? "Güncelleniyor…" : "Şifreyi güncelle"}
        </button>
      </form>
    </div>
  );
}
